import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faPhone, faHome, faLongArrowAltUp } from '@fortawesome/free-solid-svg-icons';

import logo from '../media/favicon.svg';

const currentYear = new Date().getFullYear();

function Footer() {

  return (
    <div className='footer' id='footer'>
      <div className='footer__top'>
        <div className='footer__left'>
          <div className='footer-adress'>
            <FontAwesomeIcon icon={faHome} />
            <p>
              <a href='https://www.google.com/maps/place/Industriestra%C3%9Fe+66,+28876+Oyten/@53.0570672,9.0386425,16z/data=!3m1!4b1!4m6!3m5!1s0x47b1200544fceb9d:0x96614ff3c55ce9f7!8m2!3d53.057064!4d9.0412174!16s%2Fg%2F11c32cf1rj?entry=ttu&g_ep=EgoyMDI1MDgxMC4wIKXMDSoASAFQAw%3D%3D'>
                SK-Metallbau<br/>
                Industriestr. 66<br/>
                28876 Oyten
              </a>
            </p>
          </div>
          <div className='footer-phone'>
            <FontAwesomeIcon icon={faPhone} />
            <p>
              <a href='tel:042079959039'>
                +49 4207 - 9959039
              </a>
            </p>
          </div>
          <div className='footer-mail'>
            <FontAwesomeIcon icon={faEnvelope} />
            <p>
              <a href="mailto:info@sk-metallbau.eu">
                info@sk-metallbau.eu
              </a>
            </p>
          </div>
        </div>
        <div className='footer__right'>
          <div className='footer__impressum'>
            <p>
              <a href='/impressum#impressum'>Impressum</a>
            </p>
            <p>
              | 
            </p>
            <p>
              <a href='/impressum#datenschutz'>Datenschutzerklärung</a>
            </p>
            <p>
              | 
            </p>
            <p>
              <a href='/impressum#agb'>AGB's</a>
            </p>
          </div>
          <AnchorLink href='#start'>
            <div className='top' id='top'>
              <FontAwesomeIcon icon={faLongArrowAltUp} size='1x' />
            </div>
          </AnchorLink>
        </div>
      </div>
      <div className="footer__bottom">
        <div className='footer__right'>
          <p className='copyright'>
            &copy; {currentYear} SK-Metallbau. Alle Rechte vorbehalten.
          </p>
          <img src={logo} alt='favicon' />
        </div>
      </div>
  </div>
  );
}

export default Footer;
